import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_258: DocMigration = {
  maxSchemaVersion: "0.0.258",
  description:
    "Make the RoomWallPosition edgeId reference the actual room edge id value instead of an index (e.g. `4` instead of 3) and rename props",
  apply(json: any) {
    const updatePosition = (position, roomId) => {
      if (position.type === "WALL") {
        // rename offset to lateralOffset
        if (position.offset !== undefined) {
          position.lateralOffset = position.offset;
          delete position.offset;
        }

        //rename offsetNormalizedToRoomWidth to lateralOffsetNormalizedToRoomWidth
        if (position.offsetNormalizedToRoomWidth !== undefined) {
          position.lateralOffsetNormalizedToRoomWidth = position.offsetNormalizedToRoomWidth;
          delete position.offsetNormalizedToRoomWidth;
        }

        const room = json.rooms[roomId];
        if (room === undefined) {
          return;
        }

        if (position.edgeId > room.edgeIds.length - 1) {
          // some positions have edgeIds that are greater than the number of edges in the room
          position.edgeId = room.edgeIds[position.edgeId - room.edgeIds.length];
        } else {
          position.edgeId = room.edgeIds[position.edgeId];
        }
      }
    };

    const updateController = (controller) => {
      if (controller.type === "EXPLICIT POSITION" && controller.explicitQueryPoint) {
        const { position, roomId } = controller.explicitQueryPoint;
        if (position) {
          updatePosition(position, roomId);
        }
      }
    };

    const { electricalSystem } = json;
    const { controllers, roomEmbeddedGroups, roomIndependentLoadArrays } = electricalSystem;

    // iterate over roomEmbeddedGroups
    for (const roomId in roomEmbeddedGroups) {
      const embeddedGroupKeys = Object.keys(roomEmbeddedGroups[roomId]);
      for (const embeddedGroupId of embeddedGroupKeys) {
        const embeddedGroup = electricalSystem.embeddedGroups[embeddedGroupId];

        // iterate over loadArrays
        for (const loadArray of embeddedGroup.loadArrays) {
          const load = electricalSystem.loads[loadArray.id];
          if (load !== undefined) {
            updatePosition(load.position, roomId);
          }
        }
        // iterate over inPlaceLayouts for controllers
        for (const inPlaceLayoutId in embeddedGroup.inPlaceLayouts) {
          const inPlaceLayout = embeddedGroup.inPlaceLayouts[inPlaceLayoutId];
          if (inPlaceLayout.controllerPlacementType) {
            for (const controllerPlacementType of inPlaceLayout.controllerPlacementType) {
              updateController(controllerPlacementType);
            }
          }
          if (inPlaceLayout.endControllerPlacementType) {
            for (const endControllerPlacementType of inPlaceLayout.endControllerPlacementType) {
              updateController(endControllerPlacementType);
            }
          }
        }
        // we don't need to iterate over controller ids in roomEmbeddedGroups because we can just
        // iterate over electricalSystem.controllers
      }
    }

    // iterate over loads in roomIndependentLoadArrays
    for (const roomId in roomIndependentLoadArrays) {
      const independentLoadArrayKeys = Object.keys(roomIndependentLoadArrays[roomId]);
      for (const independentLoadArrayId of independentLoadArrayKeys) {
        const independentLoadArray = electricalSystem.independentLoadArrays[independentLoadArrayId];
        for (const loadId of independentLoadArray.loads) {
          const load = electricalSystem.loads[loadId];
          if (load !== undefined) {
            updatePosition(load.position, roomId);
          }
        }
      }
    }

    // iterate over controllers
    for (const controllerId in controllers) {
      const { selections } = controllers[controllerId];
      for (const selection of selections) {
        updateController(selection);
      }
    }

    return json;
  },
};

export default migration_0_0_258;
